import secheroimg from '../assets/secheroimg.webp'
import proimg from '../assets/proimg.jpg'

const Procarddata = [
    {
        imgsrc: secheroimg,
        title: "Banking App",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut deleniti, earum perspiciatis sapiente recusandae, tenetur explicabo maiores nesciunt, fugit voluptatem eligendi est. Ratione in commodi accusamus excepturi at impedit quisquam!",
        view: "/"
    },
    {
        imgsrc: proimg,
        title: "Banking App",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut deleniti, earum perspiciatis sapiente recusandae, tenetur explicabo maiores nesciunt, fugit voluptatem eligendi est. Ratione in commodi accusamus excepturi at impedit quisquam!",
        view: "/"
    },
    {
        imgsrc: secheroimg,
        title: "Banking App",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut deleniti, earum perspiciatis sapiente recusandae, tenetur explicabo maiores nesciunt, fugit voluptatem eligendi est. Ratione in commodi accusamus excepturi at impedit quisquam!",
        view: "/"
    },

]

export default Procarddata
